/**
 * Feedback Fragment
 * Handles the feedback modal and its success panel, both of which render
 * into #feedback-modal-host in the shell and close by emptying it.
 */

import { Events } from '../../../js/utils/events.js';

let initialized = false;

// ============================================================================
// Feedback Handlers
// ============================================================================

const FeedbackHandlers = {
    /**
     * Empty the shell's modal host, which unmounts whatever is showing.
     */
    close() {
        const host = document.getElementById('feedback-modal-host');
        if (host) host.innerHTML = '';
    },

    /**
     * Close on a click on the backdrop itself, not on the panel over it.
     */
    onBackdropClick(e, element) {
        if (e.target === element) FeedbackHandlers.close();
    },

    /**
     * Close on Esc while something is mounted.
     */
    onKeyDown(e) {
        if (e.key === 'Escape' && document.getElementById('feedback-modal')) {
            FeedbackHandlers.close();
        }
    },

    /**
     * The success panel dismisses itself after the delay it declares.
     */
    startAutoClose(panel) {
        if (panel.dataset.autoCloseStarted === 'true') return;
        panel.dataset.autoCloseStarted = 'true';
        setTimeout(FeedbackHandlers.close, Number(panel.dataset.feedbackAutoClose));
    },
};

// ============================================================================
// Initialization
// ============================================================================

export function initFeedback() {
    if (initialized) return;
    initialized = true;

    Events.on('click', 'feedback-close', FeedbackHandlers.close);
    Events.on('click', 'feedback-modal-backdrop', FeedbackHandlers.onBackdropClick);

    // One listener for the life of the page rather than one per open. The
    // old inline script registered on render and only unregistered on Esc,
    // so closing any other way left it behind.
    document.addEventListener('keydown', FeedbackHandlers.onKeyDown);

    document.addEventListener('htmx:afterSwap', (event) => {
        if (!event.target.querySelectorAll) return;
        event.target
            .querySelectorAll('[data-feedback-auto-close]')
            .forEach(FeedbackHandlers.startAutoClose);
    });

    console.log('[LeapFILE] Feedback fragment initialized');
}
